<script setup lang="ts">
import { useAsyncData } from '#imports'

const { query } = useLayeredContent()

const { data: content, status } = useAsyncData('safer-gambling-content', () =>
    query('safer-gambling', '/index')
)
</script>

<template>
    <div class="responsible-gambling">
        <ContentRenderer v-if="content" :value="content" />
        <UILoader v-else-if="status === 'pending'" />
    </div>
</template>

<style lang="scss" scoped>
.responsible-gambling {
    position: relative;
    min-height: 200px;
    padding-top: 20px;
    text-align: center;

    @include tablet(md) {
        width: 70%;
        margin: 0 auto;
    }

    @include desktop-xl {
        width: 60%;
    }

    :deep(p),
    :deep(ul) {
        margin-bottom: 15px;
    }

    :deep(li > p) {
        margin-bottom: 2px;
    }

    :deep(h1) {
        font-weight: $safer-gambling-headline-font-weight;
        margin: 0 0 30px;
    }
}
</style>
